export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_54-3699285e1f190fec9ad2e26fc993dc02.jpg";